import displayToastMessage from "../components/Common/Alert/displayToastMessage"

const addCredentials = (req) => {
  req.headers.set(
    "jwtAuth",
    sessionStorage.getItem("jwtToken")
  )
}

export const interceptor = (instance) => {
  // Request interceptor
  const requestInstance = instance.interceptors.request.use(
    (req) => {
      // Whitelist of routes
      const publicRoutes = ["login", "refresh", "corporate"];

      if (!publicRoutes.some(route => req.url.includes(route))) {
        addCredentials(req);
      }

      return req;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  // Response interceptor
  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (error) => {
      const status = error.response ? error.response.status : null;
      const originalConfig = error.response.config;
      const refreshTokenKey = sessionStorage.getItem("refreshToken");
      const isNotRefresh = !error.request.responseURL.includes("refresh");

      if (status === 401 && refreshTokenKey && !originalConfig._retry && isNotRefresh) {
        originalConfig._retry = true;
        const newRes = refreshToken(originalConfig, instance, refreshTokenKey);
        return Promise.resolve(newRes);
      }

      if (status === 402) {
        sessionStorage.clear();
        window.location.reload();
      }

      return Promise.reject(error);
    }
  );
};


export async function refreshToken(orginalConfig, instance, refreshToken) {
  try {
    const refresh_response = await instance.post('/refresh',{},
      { headers: {refreshToken: refreshToken } }
    );

    sessionStorage.clear();
    sessionStorage.setItem("roleId", refresh_response.data?.data?.roleId);
    sessionStorage.setItem("userId", refresh_response.data?.data?.userId);
    sessionStorage.setItem("orgId", refresh_response.data?.data?.orgId);
    sessionStorage.setItem("loggedIn", true);
    sessionStorage.setItem("jwtToken", refresh_response.data?.data?.access_token);
    sessionStorage.setItem("refreshToken", refresh_response.data?.data?.refresh_token);
    return instance(orginalConfig);
  } catch (err) {
    if (err?.response?.data?.error === "REFRESH_TOKEN_EXPIRED"){
      displayToastMessage("Session expired, Please signin again!", "error");
      clearLoginSession(instance, { userID: sessionStorage.getItem("userId")})
      sessionStorage.clear();
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
    sessionStorage.clear();
    return Promise.reject(err);
  }
}

const clearLoginSession = (instance, body) => {
  try {
    instance.post('/login/clearLoginSession',body);
  } catch (error) {
    console.log(error);
  }
}
